export default __webpack_public_path__ + "static/media/icon-Table-Document.5379d5f6.svg";